import React, {forwardRef, useEffect, useContext, useRef, useState, useLayoutEffect} from 'react'
import _ from 'lodash'
import clsx from 'clsx'
import ItemList from '../ItemList'
import PillRows from '../PillRows'
import './GanttGroup.scss'
import SelectionRangeIndicator from '../SelectionRangeIndicator'
import {ReservationContext} from '../../../../context/Reservation'
import moment from 'moment'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import {IconButton} from '@material-ui/core'

const RootClass = 'ap-reservation-gantt'

const GanttGroupReserved = forwardRef(
  ({columnHeaders, viewBreakPoint, title = null, groupBy = null, filterValue}, ref) => {
    const [windowWResize, setWindowWResize] = useState(document.documentElement.clientWidth)
    const {reservation} = useContext(ReservationContext)
    const refTimelineEvents = useRef(null)
    const [expand, setExpand] = useState(true)

    useLayoutEffect(() => {
      if (columnHeaders.primary.length > 0) {
        const leftOffset = columnHeaders.primary[0].width - 26
        if (refTimelineEvents.current) {
          refTimelineEvents.current.scrollLeft = leftOffset
        }
      }
    }, [columnHeaders, expand, windowWResize])

    useEffect(() => {
      const f = () => {
        setWindowWResize(document.documentElement.clientWidth)
      }
      setWindowWResize(document.documentElement.clientWidth)
      window.addEventListener('resize', f)
      return () => {
        window.removeEventListener('resize', f)
      }
    }, [])

    return (
      <div
        className={clsx('ap-typography ap-typography--sm m-reservation-gantt c-gantt-group', {
          'c-gantt-group--has-title': title !== null,
        })}
      >
        {title && (
          <div
            className="c-gantt-group__title"
            title={`${title} (${reservation.selected_items.length || 0})`}
          >
            <span className="ap-ellipsis">
              {title} ({reservation.selected_items.length || 0})
            </span>
            <IconButton
              size="small"
              className="ap-icon-button ap-icon-button--square"
              style={{color: '#596175'}}
              onClick={() => setExpand(p => !p)}
            >
              {expand ? <ExpandMoreIcon /> : <ChevronLeftIcon />}
            </IconButton>
          </div>
        )}
        {expand && (
          <>
            <div className="c-gantt-group__items">
              <ItemList items={reservation.selected_items} />
            </div>
            <div className="c-gantt-group__events" style={{overflow: 'hidden'}}>
              <div
                ref={refTimelineEvents}
                className={`c-gantt__timeline-scroll ap-scrollbar`}
                data-x="date-selection"
              >
                {reservation.isSelection && (
                  <SelectionRangeIndicator
                    primaryHeaders={columnHeaders.primary}
                    startSec={moment(reservation.date_from).valueOf()}
                    endSec={moment(reservation.date_to).valueOf()}
                    items={reservation.selected_items}
                  />
                )}

                {/* Background */}
                <div className={`${RootClass}__date-bg overlay-z-index`}>
                  {_.map(columnHeaders.primary, (e, i) => (
                    <div
                      key={i}
                      id={`col-heads-primary-${i}`}
                      style={{flex: `0 0 ${e.width}px`}}
                      className={`${RootClass}__column${
                        e.label_sub === 'Sun' || e.label_sub === 'Sat' ? '--sat-sun-background' : ''
                      }`}
                    ></div>
                  ))}
                </div>

                <PillRows
                  items={reservation.selected_items}
                  breakpoint={viewBreakPoint}
                  headers={columnHeaders}
                />
              </div>
            </div>
          </>
        )}
      </div>
    )
  }
)

export default GanttGroupReserved
